import { useEffect, useRef } from 'react'

import { toBidderCountSegmentProps } from '@/helpers/listing/bidderCount'

import type { ImpressionTrackingOptions } from '../BaseCarousel/types'

export function useCarouselImpressionTracking({
  listings,
  carouselName,
  screenName = 'homepage',
  track,
  sort_type,
  carousel_variant,
  model_version,
}: ImpressionTrackingOptions) {
  const hasTrackedImpression = useRef(false)
  const impressionId = useRef(crypto.randomUUID())

  useEffect(() => {
    if (listings.length > 0 && !hasTrackedImpression.current) {
      const timer = setTimeout(() => {
        track('listing_card_impression', {
          listing_card_impression_id: impressionId.current,
          listings_count: listings.length,
          carousel_name: carouselName,
          screen_name: screenName,
          listings: listings.map((listing, index) => ({
            id: listing.id,
            position: index + 1,
            ...toBidderCountSegmentProps(listing),
          })),
          ...(sort_type !== undefined && { sort_type }),
          ...(carousel_variant !== undefined && { carousel_variant }),
          ...(model_version !== undefined && { model_version }),
        })
        hasTrackedImpression.current = true
      }, 3000)

      return () => clearTimeout(timer)
    }
  }, [
    listings,
    track,
    carouselName,
    screenName,
    sort_type,
    carousel_variant,
    model_version,
  ])

  return impressionId
}
